// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#created-by-select[data-v-751e4ece]  .vs__selected-options{-ms-flex-wrap:nowrap;flex-wrap:nowrap}#created-by-select[data-v-751e4ece]  .vs__selected{width:100%}", ""]);
// Exports
module.exports = exports;
